import { useQuery } from "@tanstack/react-query";
import { getTypeOfPlaces } from "../actions/getTypeOfPlaces";

export const useTypeOfPlacesQuery = ({ categoryType }) => {
  return useQuery({
    queryKey: ["type-of-places", categoryType],
    queryFn: () => getTypeOfPlaces({ categoryType }),
    enabled: !!categoryType,
    staleTime: 1000 * 60 * 5, //5 minutos
    retry: 1,
  });
};
